// Meta Pixel + HubSpot tracking. Loads only when IDs are set in walkthrough-config.js.
(function () {
  var cfg = window.SITE_CONFIG || {};

  // Meta Pixel
  if (cfg.metaPixelId) {
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0";
      n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    fbq("init", cfg.metaPixelId);
    fbq("track", "PageView");
  }

  // HubSpot tracking code (page views, source attribution)
  if (cfg.hubspotPortalId) {
    var hs = document.createElement("script");
    hs.id = "hs-script-loader"; hs.async = true; hs.defer = true;
    hs.src = "https://js-na2.hs-scripts.com/" + cfg.hubspotPortalId + ".js";
    document.head.appendChild(hs);
  }

  // Keep ad click IDs and UTMs across pages so they reach HubSpot.
  var KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
  var params = new URLSearchParams(location.search);
  KEYS.forEach(function (k) {
    if (params.get(k)) { try { sessionStorage.setItem(k, params.get(k)); } catch (e) {} }
  });

  window.track = function (event, data) {
    if (window.fbq) fbq("track", event, data || {});
  };
  window.trackCustom = function (event, data) {
    if (window.fbq) fbq("trackCustom", event, data || {});
  };
  window.getAttribution = function () {
    var out = {};
    KEYS.forEach(function (k) {
      try { var v = sessionStorage.getItem(k); if (v) out[k] = v; } catch (e) {}
    });
    return out;
  };
})();
